export const CATEGORIES = [
  {
    key: "people",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/1fsousrg_cat-people.jpg",
    code: "01",
  },
  {
    key: "animals",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/kltjvg1j_cat-animals.jpg",
    code: "02",
  },
  {
    key: "kids_cartoon",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/tx111g8g_cat-drawings.jpg",
    code: "03",
  },
  {
    key: "action_figures",
    image:
      "https://images.unsplash.com/photo-1608278047522-58806a6ac85b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    code: "04",
  },
  {
    key: "keychains",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/conje4hb_cat-keychains.jpg",
    code: "05",
  },
  {
    key: "home_objects",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/zoooxrzx_home%20decor%203d.webp",
    code: "06",
  },
  {
    key: "household",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/8mqthpwv_utilities%20model.jpg",
    code: "07",
  },
  {
    key: "word_art",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/y32v12po_word%20art%20model.jpg",
    code: "08",
  },
  {
    key: "custom_specific",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/t6fik87o_rainha.jpg",
    code: "09",
  },
  {
    key: "mothers_day",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/aj2gho4k_Categoria%20Pessoas%20-%20Estilo%20Realista%202.png",
    code: "10",
  },
  {
    key: "in_stock",
    image:
      "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/hh7261pw_1.avaible%20now_%20Jesus%20Keychains%20%203%20pack.jpg",
    code: "11",
  },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/he9v4nkc_Cartao%20Capa.png";

export const HERO_IMAGE =
  "https://images.pexels.com/photos/30720501/pexels-photo-30720501.jpeg?auto=compress&cs=tinysrgb&w=1600";

export const CONTACT = {
  email: "allpossible3d@gmail.com",
  phone: "929.605.7254",
};

// Order in which styles are rendered (matters when grouping)
export const STYLE_ORDER = ["realista", "funko_pop", "cartoon", "pixar", "anime"];

// Categories that show a Style picker on the Request Order form
export const STYLED_ORDER_CATEGORIES = new Set([
  "people",
  "animals",
  "mothers_day",
]);

// Per-category styles to hide from the order-form dropdown
export const HIDDEN_STYLES_PER_CATEGORY = {
  people: new Set(["realista"]),
};

// Reference / illustrative artifacts shared across categories
const ART = {
  pixarFamily1:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/j0k3nhx9_Categoria%20Pessoas%20e%20Keychain-%20Estilo%20Pixar%20%28familia%29.png",
  pixarFamily2:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/dznwthln_Categoria%20Pessoas%20e%20Keychain-%20Estilo%20Pixar%20%28familia%29%202.png",
  pixarSingle:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/o5yoza6h_Categoria%20Pessoas%20-%20Estilo%20Pixar.png",
  pixarFamily3:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/u7l6sqcx_Categoria%20Pessoas%20-%20Estilo%20Pixar%20%28familia%29.png",
  funkoPopWomanCat:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/27hp74lb_Categoria%20Pessoas%20e%20Animal%20-%20Estilo%20Funko%20Pop.png",
  funkoPopSingle2:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/d2uhw1te_Categoria%20Pessoas%20-%20Estilo%20Funko%20Pop%20single%202.png",
  funkoPopSingle3:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/h25dnqx8_Categoria%20Pessoas%20-%20Estilo%20Funko%20Pop%20single%203.png",
  funkoPopSingle4:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/vcmb1rkt_Categoria%20Pessoas%20-%20Estilo%20Funko%20Pop%20single%204.png",
  funkoPopCouple2:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/nlrxqxgv_Categoria%20Pessoas%20-%20Estilo%20Funko%20Pop%20couple%202.png",
  cartoonCouple:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/4yuk1upy_Categoria%20Pessoas%20-%20Estilo%20Cartoon.png",
  animeGirl:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/lf59mk28_Categoria%20Pessoas%20-%20Estilo%20Anime%20Japone.png",
  animeBoy2:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/58556vky_Categoria%20Pessoas%20-%20Estilo%20Anime%20Japone%202.png",
  animeBoy4:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/cvrjilgy_Categoria%20Pessoas%20-%20Estilo%20Anime%20Japone%204.png",
  realisticCouple:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/m8sicd9g_Categoria%20Pessoas%20-%20Estilo%20Realista.png",
  realisticFamily:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/aj2gho4k_Categoria%20Pessoas%20-%20Estilo%20Realista%202.png",
  childDrawing1:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/p4rb34t3_Children%20draening%20model%201.png",
  childDrawing2:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/l5bhup16_Children%20draening%20model%202.png",
  childDrawing3:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/ihtbq2j3_Children%20draening%20model%203.png",
  homeUtility:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/66ijs9pw_Categoria%20Home%20Utilities.png",
  mothersExample8:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/rkh57hpt_Categoria%20Dia%20das%20Maes_exemplo%208.png",
  mothersExample7:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/7mn7n08s_Categoria%20Dia%20das%20Maes_exemplo%207.png",
  mothersExample4:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/w7scbx0w_Categoria%20Dia%20das%20Maes_exemplo%204.png",
  mothersWordArt6:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/wc8etvvs_Categoria%20Dia%20das%20Maes%20e%20categoria%20Word%20Art_exemplo%206.png",
  mothersWordArt7:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/spz2e7lk_Categoria%20Dia%20das%20Maes%20e%20cadegoria%20Word%20Art_exemplo%207.png",
  funkoPopGoldenDog:
    "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/4xg9c6t9_Categoria%20Animal%20-%20Estilo%20Funko%20Pop.png",
};

// Gallery examples per category. Each item: { url, style? }.
// When any item has a style, the page groups them by style with a section header
// and shows the "imagens meramente ilustrativas" caption.
export const CATEGORY_EXAMPLES = {
  people: [
    { url: ART.funkoPopWomanCat, style: "funko_pop" },
    { url: ART.funkoPopSingle2, style: "funko_pop" },
    { url: ART.funkoPopSingle3, style: "funko_pop" },
    { url: ART.funkoPopSingle4, style: "funko_pop" },
    { url: ART.funkoPopCouple2, style: "funko_pop" },
    { url: ART.cartoonCouple, style: "cartoon" },
    { url: ART.pixarSingle, style: "pixar" },
    { url: ART.pixarFamily1, style: "pixar" },
    { url: ART.pixarFamily2, style: "pixar" },
    { url: ART.pixarFamily3, style: "pixar" },
    { url: ART.animeGirl, style: "anime" },
    { url: ART.animeBoy2, style: "anime" },
    { url: ART.animeBoy4, style: "anime" },
  ],
  animals: [
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/kltjvg1j_cat-animals.jpg" },
    { url: ART.funkoPopWomanCat, style: "funko_pop" },
    { url: ART.funkoPopGoldenDog, style: "funko_pop" },
  ],
  kids_cartoon: [
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/tx111g8g_cat-drawings.jpg" },
    { url: ART.childDrawing1 },
    { url: ART.childDrawing2 },
    { url: ART.childDrawing3 },
  ],
  action_figures: [
    { url: "https://images.unsplash.com/photo-1608278047522-58806a6ac85b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  ],
  keychains: [
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/conje4hb_cat-keychains.jpg" },
    { url: ART.pixarFamily1, style: "pixar" },
    { url: ART.pixarFamily2, style: "pixar" },
  ],
  home_objects: [
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/zoooxrzx_home%20decor%203d.webp" },
  ],
  household: [
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/8mqthpwv_utilities%20model.jpg" },
    { url: ART.homeUtility },
  ],
  word_art: [
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/y32v12po_word%20art%20model.jpg" },
    { url: ART.mothersWordArt6 },
    { url: ART.mothersWordArt7 },
  ],
  custom_specific: [
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/t6fik87o_rainha.jpg" },
  ],
  mothers_day: [
    { url: ART.mothersExample8 },
    { url: ART.mothersExample7 },
    { url: ART.mothersExample4 },
    { url: ART.mothersWordArt6 },
    { url: ART.mothersWordArt7 },
    { url: ART.realisticFamily, style: "realista" },
    { url: ART.realisticCouple, style: "realista" },
    { url: ART.cartoonCouple, style: "cartoon" },
    { url: ART.pixarFamily1, style: "pixar" },
    { url: ART.pixarFamily2, style: "pixar" },
    { url: ART.pixarFamily3, style: "pixar" },
  ],
  in_stock: [
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/hh7261pw_1.avaible%20now_%20Jesus%20Keychains%20%203%20pack.jpg" },
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/g1f3308r_1.avaible%20now_%20Jesus%20Keychains%20.jpg" },
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/cmbyx2in_1.avaible%20now_%20Jesus%20Keychains%20%20with%20mom.jpg" },
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/xcwh5ant_1.avaible%20now_%20Batman%202.jpg" },
    { url: "https://customer-assets.emergentagent.com/job_print-3d-hub-3/artifacts/2wjp75ay_1.avaible%20now_%20Starfish%20keychain.jpg" },
  ],
};
